import {
  format,
  isToday,
  isThisYear,
  isAfter,
  startOfDay,
  differenceInYears,
  differenceInMonths,
  differenceInWeeks,
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
} from 'date-fns';

export const dateToUTC = date => {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      0,
    ),
  );
};

export const removeDateTimezoneOffset = date => {
  const timezoneOffset = date.getTimezoneOffset();

  const utcDate = new Date(date.getTime() + timezoneOffset * 60 * 1000);

  return utcDate;
};

export const hasUtcRolledOverToNewDay = () => {
  const now = new Date();

  const localStartOfDay = startOfDay(now);
  const utcStartOfDay = startOfDay(new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())));

  return isAfter(utcStartOfDay, localStartOfDay);
};

export const formatChatDate = dateInput => {
  const date = new Date(dateInput);

  if (isToday(date)) {
    return format(date, 'HH:mm');
  }

  if (isThisYear(date)) {
    return format(date, 'MMM dd'); // e.g. "Dec 22"
  }

  return format(date, 'dd/MM/yyyy');
};

export const timeAgo = date => {
  const d = new Date(date);
  const now = new Date();

  const years = differenceInYears(now, d);
  if (years > 0) return `${years} Year${years > 1 ? 's' : ''} Ago`;

  const months = differenceInMonths(now, d);
  if (months > 0) return `${months} Month${months > 1 ? 's' : ''} Ago`;

  const weeks = differenceInWeeks(now, d);
  if (weeks > 0) return `${weeks} Week${weeks > 1 ? 's' : ''} Ago`;

  const days = differenceInDays(now, d);
  if (days > 0) return `${days} Day${days > 1 ? 's' : ''} Ago`;

  const hours = differenceInHours(now, d);
  if (hours > 0) return `${hours} Hour${hours > 1 ? 's' : ''} Ago`;

  const minutes = differenceInMinutes(now, d);
  if (minutes > 0) return `${minutes} Minute${minutes > 1 ? 's' : ''} Ago`;

  const seconds = differenceInSeconds(now, d);
  if (seconds > 10) return `${seconds} Seconds Ago`;

  return 'Just Now';
};

export const timeAgoV2 = date => {
  const d = new Date(date);
  const now = new Date();

  const seconds = differenceInSeconds(now, d);
  if (seconds < 60) return `${seconds} Seconds Ago`;

  const minutes = differenceInMinutes(now, d);
  if (minutes < 60) return `${minutes} Minute${minutes > 1 ? 's' : ''} Ago`;

  const hours = differenceInHours(now, d);
  if (hours < 60) return `${hours} Hour${hours > 1 ? 's' : ''} Ago`;

  return d.toDateString();
};

export const isFirstDayOfMonthBeforeNoonUTC = () => {
  const now = new Date();

  const isFirstDay = now.getUTCDate() === 1;

  const hoursUTC = now.getUTCHours();

  return isFirstDay && hoursUTC < 12;
};
